/* UltraTrack DISPLAY-ONLY "ghost" SKU — product pages + cart.
   Computes UT-<SERIES>-<PREFIX><SIZE><SUFFIX><-NM>-<TREAD> from the product TITLE
   (single source of truth, so product page and cart always match) and swaps it
   wherever a SKU shows. NEVER changes the real variant SKU — cart line items,
   checkout, and the order in admin all keep the vendor SKU. Track-scoped:
   only fires on rubber-track titles that carry a WxHxL size (see isTrackTitle). */
(function () {
  function seg(s){ return String(s==null?'':s).toUpperCase().replace(/×/g,'X').replace(/[^A-Z0-9.]+/g,'-').replace(/^-+|-+$/g,''); }
  function treadCode(t){ return seg(String(t==null?'':t).replace(/\s*tread\s*$/i,'')); }
  /* Tread names mirroring the War-Room `tread_types` vocabulary that the portal
     stores in products.tread_type. Order does NOT matter: matching is whole-token
     and LONGEST-wins (see firstTread), so 'non-marking l' beats 'l'.
     The previous 20-name list matched with indexOf() and had two defects:
       - substring: 'MTL TREAD' contains 'L TREAD', so NMC MTL tracks rendered
         UT-...-L (16103528 and 17150442 were live examples);
       - coverage: 24 tread names in active use had no entry at all (143 products),
         so they rendered with no tread token.
     'non-marking ...' variants are deliberately ABSENT: non-marking is already
     encoded by the separate -NM marker, and including them produced
     UT-...-NM-NON-MARKING-L. */
  var TREADS = ['2nd gen multi bar','ag','asv','bi-directional l','block','block chain bi-directional',
    'c pattern','chevron','d1','d2','d3','demolition','grooved directional','h',
    'l','maximum','mgd','mini bat','mtl','mtl1','multi bar','n','nmc all terrain','nmc mtl',
    'nmc multi bar','non-directional','notched t','posi trac','r-1','s','s lug','s wave',
    'slanted t','smooth','snow','split bar','staggered','staggered directional','staggered l',
    'staggered t','straight bar','t block','t5','toggle','turf','v lug','wide lug','z','z pattern'];

  /* Alias phrases -> canonical tread, mirroring `tread_types.keywords`. The list
     above holds canonical NAMES (the matched entry is the token); these are the
     War-Room synonyms whose token must be a DIFFERENT name. Longest phrase wins
     across both, so 'staggered block' beats 'staggered'. Keep in sync with the
     War Room: e.g. Block Tread carries keyword "Staggered Block", so a title
     reading "Staggered Block Tread" must render -BLOCK, not -STAGGERED. */
  var TREAD_ALIASES = {
    'staggered block':'block',
    'stag block':'block',
    'block inter':'block',
    'block pattern':'block',
    'c block':'c pattern',
    'r1':'r-1',
    'r1 lug':'r-1',
    'r1-lug':'r-1',
    'c-lug':'c pattern',
    'c tread':'c pattern'
  };

  function isWordChar(c){ return (c >= '0' && c <= '9') || (c >= 'A' && c <= 'Z'); }

  /* Whole-token containment: the needle may not be flanked by a letter or digit.
     Regex-free so there is no escaping to get wrong on names like 'r-1'. */
  function hasTread(up, name){
    var n = name.toUpperCase(), from = 0, i;
    while ((i = up.indexOf(n, from)) !== -1){
      var before = (i === 0) ? '' : up.charAt(i - 1);
      var after  = up.charAt(i + n.length);
      if (!isWordChar(before) && !isWordChar(after)) return true;
      from = i + 1;
    }
    return false;
  }

  /* Longest match wins, so the most specific tread name is used. Try the name
     followed by TREAD first, then bare, so 'L TREAD' is preferred over a stray 'L'. */
  function firstTread(up){
    var best = '', bestCanon = '';
    function consider(phrase, canon){
      if (phrase.length <= best.length) return;
      if (hasTread(up, phrase + ' TREAD') || hasTread(up, phrase)){ best = phrase; bestCanon = canon; }
    }
    for (var i = 0; i < TREADS.length; i++) consider(TREADS[i], TREADS[i]);
    for (var k in TREAD_ALIASES) if (Object.prototype.hasOwnProperty.call(TREAD_ALIASES, k)) consider(k, TREAD_ALIASES[k]);
    return bestCanon;
  }
  /* Track gate. The original gate required the literal word "UltraTrack" in the
     TITLE, which silently skipped 78 live rubber tracks whose titles carry a
     supplier brand instead ("300x52.5Kx90 Vortex B1-Lug Inter Track", "762x152.5x42
     Arisun NA NMC Track"), no brand at all ("Rubber Track, 10\" 250 x 72 x 52,
     Non-Marking L Tread"), or a misspelt one ("Ultra Track"/"Ultrack"/"Ultrarack"/
     "UltaTrack" X Series) — those pages kept showing the vendor SKU (task 6382).
     So: accept any title that says Ultra(-)Track, else accept a title carrying the
     word TRACK unless it names a non-track product. The word gate alone already
     excludes every non-track item in the catalog (steel chains, TWA solid tires and
     hardware bolts name no "track"); NOT_A_TRACK is a guard for future titles.
     Steel-undercarriage items whose name CONTAINS the word track (track chain /
     group / adjuster / shoe / pad) are listed too, or "Track Chain, 300 x 101 x 46"
     would be issued a fake rubber-track SKU (task 6382 rev 2). */
  var NOT_A_TRACK = /solid\s*tire|\bTWA\b|with\s+rim|steel\s+chain|\bsprocket\b|\bidler\b|\bbolt\b|\broller\b|final\s+drive|track\s+(?:chains?|groups?|adjusters?|shoes?|pads?)\b/i;
  function isTrackTitle(T){
    // Exclusion runs FIRST: "UltraTrack Bolt - M20 x 60 x1.5" is branded but is not a
    // track, and letting the brand short-circuit gave it a track SKU (UT-…-20X60X1).
    if (NOT_A_TRACK.test(T)) return false;            // UltraArmor tires, chains, hardware
    if (/ultra\s*-?\s*track/i.test(T)) return true;   // UltraTrack / Ultra Track / Ultra-Track
    return /\btracks?\b/i.test(T);
  }

  /* Series fallback when the title carries no series word. Mirrors the portal's
     own rule (Catalog.TitleComposer.series_for/1): MITCO codes are long and
     prefixed 17 (HDX) or 16 (X); everything shorter is a PartsASAP/UT code = Pro.
     Without this every newly-covered track would render the "NA" placeholder. */
  function seriesFromSku(sku){
    var s = String(sku==null?'':sku).toUpperCase().replace(/[^A-Z0-9]/g,'');
    if (s.length < 7) return s ? 'PRO' : '';
    if (s.slice(0,2)==='17') return 'HDX';
    if (s.slice(0,2)==='16') return 'X';
    return 'PRO';
  }

  function ghost(T, vendorSku){
    T = T || '';
    if (!isTrackTitle(T)) return '';                       // track gate: skip tires, chains, hardware
    var up = T.toUpperCase();
    // "UltraTrack X ..." first, then a bare "X Series" (the misspelt-brand titles).
    var sm = up.match(/ULTRA\s*-?\s*TRACK\s+(HDX|PRO|PREMIUM|AG|X)\b/) || up.match(/\b(HDX|PRO|PREMIUM|AG|X)\s+SERIES\b/);
    var series = sm ? sm[1] : (seriesFromSku(vendorSku) || 'NA');
    /* Size gate. Case-insensitive ("320X86X53") and each letter token may be up
       to three letters ("450x86x52SB", "400x72.5KMx72") — task 6382 rev 2.
       Rev 3: the SUFFIX token must sit directly against the links number, with
       no whitespace — exactly like TrackDimensions' parser — so a spaced tread
       word is never read as a suffix ("450x81Nx78 N Tread" used to render the
       phantom guide "...78N-N"; 5 live titles). The mid token keeps its \s*
       ("52.5 K x" tolerance), matching TrackDimensions again. */
    var m = T.match(/\b([A-Za-z]{0,3})\s*(\d{2,4})\s*[x×]\s*(\d{1,3}(?:\.\d)?)\s*([A-Za-z]{0,3})\s*[x×]\s*(\d{1,4})([A-Za-z]{0,3})\b/i);
    if (!m) return '';                                      // size gate: no WxHxL -> not an encodable track
    var prefix = (m[1] && /^[bt]$/i.test(m[1])) ? m[1].toUpperCase() : '';
    var size = m[2] + 'x' + m[3] + (m[4]||'') + 'x' + m[5];
    /* Rev 3: the glued suffix renders VERBATIM, like the mid token already did.
       Filtering it to K/N/W made two different products share one SKU
       ("300x52.5x88KBN" and "300x52.5x88", both Staggered T, both UT-PRO-
       300X52.5X88-STAGGERED-T). The suffix is part of the size token the
       customer reads on the page, so keeping it is both unique and faithful.
       (Guide SEMANTICS are unaffected — compatibility never derives from this
       display-only SKU; K/N/W-only remains the rule for spec_key identity.) */
    var suffix = m[6] ? m[6].toUpperCase() : '';
    var tread = firstTread(up);
    var nm = /non.?marking/i.test(T) ? '-NM' : '';
    return 'UT-' + series + '-' + prefix + seg(size) + (suffix?seg(suffix):'') + nm + (tread?'-'+treadCode(tread):'');
  }
  window.UTGhost = ghost;

  /* The vendor SKU an element is showing, ignoring a ghost we already wrote.
     Every element we overwrite keeps the original in data-ut-src, so the repeat
     runs (timer, variant:change, cart mutations) never re-read our own output —
     which would otherwise lose the series the SKU prefix encodes. */
  function skuOf(el){
    if (!el) return '';
    var t = String(el.textContent==null?'':el.textContent).replace(/^\s*SKU:\s*/i,'').trim();
    if (t && !/^UT-/i.test(t)) return t;
    return String(el.getAttribute('data-ut-src')||'').trim();
  }
  function remember(el){
    var t = String(el.textContent==null?'':el.textContent).replace(/^\s*SKU:\s*/i,'').trim();
    if (t && !/^UT-/i.test(t)) el.setAttribute('data-ut-src', t);
  }

  var SKU_SEL = '.pp-sku, .product__sku, #pp-spec-sku-val';

  function productSku(){
    var els = document.querySelectorAll(SKU_SEL);
    for (var i=0;i<els.length;i++){ var s = skuOf(els[i]); if (s) return s; }
    return '';
  }

  function productGhost(){
    // Try several title sources; use the first that yields a valid track SKU.
    // (ShopifyAnalytics.meta.product.title is sometimes a stripped variant that
    // won't parse — the on-page H1 is the reliable one.)
    var cands = [];
    var h = document.querySelector('.product__title, .pp-title, h1'); if (h) cands.push(h.textContent);
    try { if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) cands.push(ShopifyAnalytics.meta.product.title); } catch(e){}
    var sku = productSku();
    for (var i=0;i<cands.length;i++){ var g = ghost(cands[i], sku); if (g) return g; }
    return '';
  }

  function applyProduct(){
    var g = productGhost(); if (!g) return;
    document.querySelectorAll('.product__sku').forEach(function(el){
      if (el.getAttribute('data-ut')===g) return; var lab = el.querySelector('.visually-hidden');
      remember(el);
      el.classList.remove('visibility-hidden'); el.textContent=''; if (lab) el.appendChild(lab);
      el.appendChild(document.createTextNode(g)); el.setAttribute('data-ut',g);
    });
    document.querySelectorAll('.pp-sku').forEach(function(el){ var w='SKU: '+g; if (el.textContent!==w) { remember(el); el.textContent=w; } });
    var sv = document.getElementById('pp-spec-sku-val'); if (sv && sv.textContent!==g) { remember(sv); sv.textContent=g; }
  }

  function applyCart(){
    document.querySelectorAll('.cart-item__name').forEach(function(nameEl){
      var box = nameEl.closest('.cart-item__details, .cart-item, td, li, tr') || nameEl.parentNode;
      // Collect the line's SKU spans FIRST: the vendor SKU they still hold is what
      // gives the series, and the page and the cart must derive it the same way.
      var spans = [];
      box.querySelectorAll('span').forEach(function(sp){ if (/SKU:/i.test(sp.textContent)) spans.push(sp); });
      var vendorSku = '';
      for (var i=0;i<spans.length && !vendorSku;i++) vendorSku = skuOf(spans[i]);
      var g = ghost(nameEl.textContent, vendorSku); if (!g) return;
      spans.forEach(function(sp){
        if (sp.getAttribute('data-ut')===g) return;
        remember(sp);
        var strong = sp.querySelector('strong');
        sp.textContent=''; if (strong) sp.appendChild(strong); else { var s=document.createElement('strong'); s.textContent='SKU:'; sp.appendChild(s); }
        sp.appendChild(document.createTextNode(' '+g)); sp.setAttribute('data-ut',g);
      });
    });
  }

  function run(){
    try{ applyProduct(); }catch(e){}
    try{ applyCart(); }catch(e){}
    // Reveal the SKU (un-hide). On make-model pages the mm-regen snippet owns the reveal
    // (it reformats the legacy SKU), so we leave it alone there.
    if (window.__utReveal && !window.__utMakeModel) window.__utReveal();
  }
  if (document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
  [200,600,1300].forEach(function(d){ setTimeout(run,d); });
  ['cart:refresh','cart:updated','variant:change'].forEach(function(ev){ document.addEventListener(ev, function(){ setTimeout(run,30); }); });
  try {
    new MutationObserver(function(muts){
      for (var i=0;i<muts.length;i++){ var t=muts[i].target;
        if (t && t.querySelector && (t.querySelector('.cart-item__name') || t.querySelector('.pp-sku'))) { run(); return; }
      }
    }).observe(document.body, { subtree:true, childList:true });
  } catch(e){}
})();
